import axiosInterceptor from '../../interceptor/axiosClient';
import { forgotPasswordEmail } from '../types';

export const forgotPassword = async (forgotPasswordData: forgotPasswordEmail) => {
  const data = await axiosInterceptor.post('reset-password/', forgotPasswordData, {});

  return data.data;
};
